import { useTar } from '@/modules/i18n/useTar'

export const HomePageFooterNote = () => {
  const { t } = useTar()

  return (
    <div className="text-center pb-8">
      <p className="text-muted text-sm">{t('home.footerNote')}</p>
    </div>
  )
}
